import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';
import RichText from '../../util/RichText';
import getBackgroundColor from '../../util/getBackgroundColor';
import { Media } from '../Media/Media';
import getCardDetails from '../../util/getCardDetails';

const BlogImageContentContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  margin-top: 2rem;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: revert;
    font-family: revert;
    line-height: normal;
    font-weight: revert;
    margin: revert;
  }
  ol,
  ul {
    list-style: revert;
    padding-left: 20px;
  }
  ${EmotionBreakpoint('desktop')} {
    max-width: 970px;
  }
  ${EmotionBreakpoint('tablet')} {
    max-width: 720px;
  }
  ${EmotionBreakpoint('mobile')} {
    .back-to-home {
      margin-left: 25px;
    }
  }
  @media (min-width: 576px) and (max-width: 768px) {
    max-width: 540px;
  }
  .main-container {
    display: flex;
    flex-direction: row;
    .content-container {
      width: 80%;
    }
    .media-container {
      margin: 2rem;
      width: 34%;
    }
  } 
  ${EmotionBreakpoint('mobile')} {
    .main-container{
      flex-direction: column; 
   .content-container {
      width: 100%;
      padding: 0 15px;
   }
   .media-container {
      width: 45%;
      margin: 10px auto;
   }
   }
  }
 }
`;

const BlogImageContent = ({ fields }) => {
  let imageDetails = getCardDetails(fields?.blocks);
  const bgColor = getBackgroundColor(fields?.backgroundColor);
  const content =
    fields?.blocks && fields?.blocks[0]?.fields?.content ? RichText(fields?.blocks[0]?.fields?.content) : null;
  const mobContent =
    fields?.blocks && fields?.blocks[0]?.fields?.mobileContent
      ? RichText(fields?.blocks[0]?.fields?.mobileContent)
      : null;

  const displayContent = window.innerWidth < 768 && mobContent ? mobContent : content;

  return (
    <BlogImageContentContainer>
      <div className="main-container">
        {fields?.alignment === 'left' ? (
          <>
            <div className="media-container">
              <Media
                src={imageDetails?.backgroundImage}
                srcMob={imageDetails?.mobileBackgroundImage}
                alt={'imageAlt'}
              />
            </div>
            <div className="content-container">{displayContent}</div>
          </>
        ) : (
          <>
            <div className="content-container">{displayContent}</div>
            <div className="media-container">
              <Media
                src={imageDetails?.backgroundImage}
                srcMob={imageDetails?.mobileBackgroundImage}
                alt={'imageAlt'}
              />
            </div>
          </>
        )}
      </div>
    </BlogImageContentContainer>
  );
};

export { BlogImageContent };
